// Mock data for Service Management Consultancy Africa

export const companyInfo = {
  name: "Service Management Consultancy Africa",
  shortName: "SMC Africa",
  tagline: "...adding Intellectual Value to the System of Service...",
  description: "Service Management Consultancy (SMC) is a firm comprising of Certified Management Consultants with a shared objective of using research, innovation, and strategy to facilitate the socio-economic development of Africa.",
  vision: "To be the leading consultancy firm in Africa, providing innovative and strategic solutions that drive sustainable socio-economic development.",
  mission: "To facilitate the socio-economic development of Africa by adding intellectual value to the system of service through research, innovation, and strategy.",
  whatsapp: "+2348114445557",
  phone: ["+234 8114445557", "+234 9073409093"],
  email: "admin@smcnigeria.com",
  address: "No 3, Indus Close, Wuse II, Abuja, Off Euphrates Crescent, Off Aminu Kano Crescent, F.C.T-Nigeria",
  website: "www.smcnigeria.com"
};

export const metrics = [
  { value: "670+", label: "Customers" },
  { value: "100+", label: "Years Cumulative Experience" },
  { value: "500+", label: "Innovative Projects" },
  { value: "16+", label: "Dedicated Experts" }
];

export const services = [
  {
    id: 1,
    icon: "Target",
    title: "Strategy Development",
    description: "We develop strategies, advise and implement effective strategies to drive growth, increase efficiency, and create value for your organization.",
    features: [
      "Develop comprehensive strategies",
      "Advise and implement effective strategies",
      "Drive organizational growth",
      "Increase operational efficiency",
      "Create sustainable value"
    ]
  },
  {
    id: 2,
    icon: "Briefcase",
    title: "Program & Project Development",
    description: "From initial assessment to documentation and reporting, we provide end-to-end program and project development services.",
    features: [
      "Initial Assessment",
      "Analysis and Planning",
      "Stakeholder Engagement",
      "Program Design and Development",
      "Conceptualization of Solutions",
      "Project Implementation Support",
      "Monitoring and Evaluation",
      "Documentation and Reporting"
    ]
  },
  {
    id: 3,
    icon: "Scale",
    title: "Legal Advisory",
    description: "Comprehensive legal advisory services to support your business operations and compliance requirements.",
    features: [
      "Corporate structuring",
      "Drafting of agreements and resolutions",
      "Memorandum of Understanding (MOUs)",
      "Power of Attorney",
      "Legal opinions and consulting"
    ]
  },
  {
    id: 4,
    icon: "Laptop",
    title: "Information & Communication Technology",
    description: "Transform your business with our comprehensive ICT solutions, from software development to digital transformation.",
    features: [
      "Software Development",
      "Digital Transformation",
      "IT Support and Managed Services",
      "E-commerce Solutions",
      "Data Analytics"
    ]
  },
  {
    id: 5,
    icon: "Search",
    title: "Sector Research & Analysis",
    description: "Best practice research and analysis tailored to local issues, helping you identify opportunities and develop effective strategies.",
    features: [
      "Best Practice Research",
      "Local context analysis",
      "Identify new opportunities",
      "Market intelligence",
      "Develop effective strategies"
    ]
  },
  {
    id: 6,
    icon: "Users",
    title: "Capacity Building & Training",
    description: "Comprehensive training and development services to build high-performing teams and enhance organizational capabilities.",
    features: [
      "Training and development services",
      "Skills and capabilities development",
      "Leadership programs",
      "Build high-performing teams",
      "Organizational capacity enhancement"
    ]
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Sukky Odabi Esq.",
    role: "Certified Management Consultant",
    specialization: "Strategy & Innovation",
    description: "Diplomat, Lawyer, and Innovative Researcher with over 21 years' experience. Developed many Programs and Projects for MDAs.",
    image: "https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/uiqf9s9s_DR.%20SUKKY%20ODABI%20Esq.jpg"
  },
  {
    id: 2,
    name: "Chidinma Okere-Kadiri",
    role: "Corporate Strategy Manager",
    specialization: "ICT & Digital Transformation",
    description: "ICT consultant and expert advising regulators & major entities on financial services, energy, and public sector. Worked with KPMG on enterprise growth and digital transformation.",
    image: "https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/7rqnows5_CHIDINMA%20OKERE-KADIRI.png"
  },
  {
    id: 3,
    name: "Uche Nwachukwu",
    role: "Development Expert",
    specialization: "International Development & Finance",
    description: "Expert with Four (4) Master's Degrees. Consulted for The United Nations, KPMG, Dangote Foundation, DFID, World Bank, Bank of Industry, and WHO.",
    image: "https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/26b9izfc_UCHE%20NWACHUKWU.png"
  },
  {
    id: 4,
    name: "Ibrahim Abdullahi Shelleng",
    role: "Business Development Consultant",
    specialization: "Strategic Business & Financial Services",
    description: "Consultant on strategic business development & financial services with a proven record of optimizing transactional processes & workflows.",
    image: "https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/evwuwh8d_IBRAHIM%20ABDULLAHI%20SHELLENG.jpg"
  },
  {
    id: 5,
    name: "Donald Bobai Akut",
    role: "Political & Foreign Affairs Consultant",
    specialization: "Foreign Affairs & Government Relations",
    description: "Political Scientist with wealth of experience as a Foreign Service Officer and Special Adviser to the Speaker of the Plateau State House of Assembly.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  },
  {
    id: 6,
    name: "Adedotun Ajibola",
    role: "M&E Expert",
    specialization: "Monitoring & Evaluation",
    description: "Certified Monitoring and Evaluation Expert and Consultant to various WORLD BANK Programs and Projects. Has traveled to 25 countries and experienced in Value addition.",
    image: "https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/e17gt0vs_Adedotun%20Ajibola.gif"
  }
];

export const projects = [
  {
    id: 1,
    title: "National Re-branding Initiative",
    description: "Nigeria @Fifty Global Tour - National project of re-branding Nigeria's image abroad",
    client: "Federal Ministry of Information and Communication",
    category: "National Development"
  },
  {
    id: 2,
    title: "FIFA U-17 World Cup Ceremony",
    description: "Conceptualization and design of opening/closing ceremony endorsed by the Presidency and National Sports Commission",
    client: "The Presidency",
    category: "Sports & Entertainment"
  },
  {
    id: 3,
    title: "MSME Development Model",
    description: "Sustainable model for MSME subsector development and SMEDS-P implementation",
    client: "SMEDAN",
    category: "Economic Development"
  },
  {
    id: 4,
    title: "Financial Inclusion Initiative",
    description: "Facilitated financial inclusion through eMoneynet initiative supported by CBN",
    client: "Central Bank of Nigeria",
    category: "Financial Services"
  },
  {
    id: 5,
    title: "Elder Care Program",
    description: "Program to bridge care gap for elders in Africa",
    client: "Federal Ministry of Health",
    category: "Healthcare"
  },
  {
    id: 6,
    title: "Zamfara Water Supply Project",
    description: "Urban water supply project implementation",
    client: "Zamfara State Government",
    category: "Infrastructure"
  },
  {
    id: 7,
    title: "Sukuk Bond Advisory",
    description: "Advisory services in capital raise - Over N65 billion in Sukuk Bonds for Federal and State",
    client: "Federal & State Governments",
    category: "Financial Advisory"
  },
  {
    id: 8,
    title: "NAPWAP Platform",
    description: "Project Watch Portal using Artificial Intelligence for monitoring and evaluation",
    client: "Federal Government",
    category: "Technology"
  }
];

export const clients = [
  "Federal Ministry of Health",
  "The Presidency",
  "Small & Medium Enterprises Development Agency of Nigeria (SMEDAN)",
  "UK Aid",
  "United Nations",
  "National Assembly",
  "Federal Ministry of Information and Communication",
  "Federal Ministry of Foreign Affairs",
  "Zamfara State Government",
  "Kwara State Government",
  "Dangote Foundation",
  "The Berkeley School",
  "Central Bank of Nigeria",
  "World Bank",
  "Department for International Development (DFID)",
  "World Health Organization (WHO)",
  "Bank of Industry"
];

export const sectors = [
  "Health",
  "Security and Intelligence",
  "Petroleum",
  "Technology",
  "Solid Minerals",
  "Oil and Gas",
  "Foreign Affairs",
  "Agriculture",
  "Police Affairs",
  "Development",
  "Commerce",
  "Defence and Army",
  "Education",
  "Finance",
  "National Planning",
  "Banking and Insurance",
  "Power"
];

export const certifications = [
  "PMP Certified",
  "Certified Management Consultant",
  "Chartered Management Institute",
  "ACCA",
  "Nigerian Bar Association",
  "Institute of Business Consulting"
];
